<template lang="pug">
panel-directory(
  title="Муниципалитет"
  :action-type="actionType"
  :api-method="$rApi.directories.getMuns"
  :api-query="apiQuery"
  :input-attrs="inputAttrs"
  :refresh-key="regionId"
  no-reset
  v-bind="$attrs"
  v-on="$listeners"
)
</template>

<script>
import PanelDirectory from './PanelDirectory.vue';
import { ROW_ACTION_KEY } from '../constants';

export default {
  name: 'PanelMunicipality',
  components: {
    PanelDirectory,
  },
  props: {
    regionId: {
      type: [Number, Object],
      default: () => null,
    },
  },
  data() {
    return {};
  },
  computed: {
    actionType() {
      const { indicate } = ROW_ACTION_KEY;

      return indicate;
    },
    apiQuery() {
      return {
        'search[region_id]': this.regionId,
      };
    },
    inputAttrs() {
      return {
        placeholder: 'Найти муниципалитет',
      };
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
